"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _themeModule = _interopRequireDefault(require("../../../styles/theme.module.css"));

var _pagerModule = _interopRequireDefault(require("./pager.module.css"));

var _reactI18next = require("react-i18next");

var _resourceKeys = require("../providers/translations/resources/resourceKeys");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getPagerConfig = function getPagerConfig(totalPages, page, pageSize, totalItems) {
  var pagesBoundry = 6.0;
  var pageNum = page;
  var nextPageNo = pageNum < totalPages ? pageNum + 1 : totalPages;
  var prevPageNo = pageNum > 1 ? pageNum - 1 : 1;
  var startPage = pageNum - Math.floor(pagesBoundry / 2);

  if (startPage < 1) {
    startPage = 0;
  }

  var maxPages = startPage + pagesBoundry > totalPages ? totalPages : startPage + pagesBoundry;

  if (maxPages > totalPages) {
    maxPages = totalPages;
  }

  var firstItemOnPage = (page - 1) * pageSize + 1;
  var lastItemOnPage = page === maxPages ? totalItems : (page - 1) * pageSize + pageSize;
  return {
    firstItemOnPage: firstItemOnPage,
    lastItemOnPage: lastItemOnPage,
    startPage: startPage,
    nextPageNo: nextPageNo,
    prevPageNo: prevPageNo,
    maxPages: maxPages
  };
};

var Pager = function Pager(props) {
  var id = props.id,
      pageSize = props.pageSize,
      totalItems = props.totalItems,
      totalPages = props.totalPages,
      page = props.page,
      goAtPrevious = props.goAtPrevious,
      goAtNext = props.goAtNext,
      goAtStart = props.goAtStart,
      goAtEnd = props.goAtEnd,
      goAtPage = props.goAtPage,
      _props$firstPageTestI = props.firstPageTestId,
      firstPageTestId = _props$firstPageTestI === void 0 ? 'first-page' : _props$firstPageTestI,
      _props$previousPageTe = props.previousPageTestId,
      previousPageTestId = _props$previousPageTe === void 0 ? 'previous-page' : _props$previousPageTe,
      _props$lastPageTestId = props.lastPageTestId,
      lastPageTestId = _props$lastPageTestId === void 0 ? 'last-page' : _props$lastPageTestId,
      _props$nextPageTestId = props.nextPageTestId,
      nextPageTestId = _props$nextPageTestId === void 0 ? 'next-page' : _props$nextPageTestId,
      _props$paginationWrap = props.paginationWrapperTestId,
      paginationWrapperTestId = _props$paginationWrap === void 0 ? 'pagination-control' : _props$paginationWrap,
      _props$paginationReco = props.paginationRecordsShownTestId,
      paginationRecordsShownTestId = _props$paginationReco === void 0 ? 'records-shown' : _props$paginationReco;
  var pagerConfig = getPagerConfig(totalPages, page, pageSize, totalItems);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return _react.default.createElement("div", {
    id: id ? id : null,
    className: (0, _classnames.default)(_themeModule.default.arag, _pagerModule.default["pager"])
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_pagination_values") : null,
    className: (0, _classnames.default)(_pagerModule.default["col-sm-3"], _pagerModule.default["pagination-display-values"]),
    "data-testid": paginationRecordsShownTestId
  }, t(_resourceKeys.resourceKeys.showPagesOfTotalItems.key, {
    firstItemOnPage: pagerConfig.firstItemOnPage,
    lastItemOnPage: pagerConfig.lastItemOnPage,
    totalItems: totalItems
  })), _react.default.createElement("div", {
    id: id ? "".concat(id, "_pagination_buttons_wrapper") : null,
    className: _pagerModule.default["col-sm-9"] // Pagination wrapper data-testid
    ,
    "data-testid": paginationWrapperTestId
  }, _react.default.createElement("nav", {
    id: id ? "".concat(id, "_pagination_navigation_buttons") : null,
    "aria-label": "Page navigation"
  }, _react.default.createElement("ul", {
    id: id ? "".concat(id, "_pagination_buttons_list") : null,
    className: _pagerModule.default["pagination"]
  }, _react.default.createElement("li", {
    id: id ? "".concat(id, "_pagination_buttons_item_1") : null
  }, _react.default.createElement("button", {
    id: id ? "".concat(id, "_pagination_item_1_button") : null,
    type: "button",
    "aria-label": "First",
    value: "1",
    title: t(_resourceKeys.resourceKeys.firstPage.key),
    onClick: goAtStart,
    "data-testid": firstPageTestId // First page button data-testid

  }, _react.default.createElement("span", {
    id: id ? "".concat(id, "_pagination_item_1_button_glyphicon_vertical") : null,
    "aria-hidden": "true",
    className: (0, _classnames.default)(_pagerModule.default["glyphicon"], _pagerModule.default["glyphicon-option-vertical"])
  }), _react.default.createElement("span", {
    id: id ? "".concat(id, "_pagination_item_button_glyphicon_chevron_left") : null,
    "aria-hidden": "true",
    className: (0, _classnames.default)(_pagerModule.default["glyphicon"], _pagerModule.default["glyphicon-chevron-left"])
  }))), _react.default.createElement("li", {
    id: id ? "".concat(id, "_pagination_buttons_item_2") : null
  }, _react.default.createElement("button", {
    id: id ? "".concat(id, "_pagination_item_2_button") : null,
    type: "button",
    "aria-label": "Previous",
    value: pagerConfig.prevPageNo,
    title: t(_resourceKeys.resourceKeys.previousPage.key),
    onClick: goAtPrevious,
    "data-testid": previousPageTestId // Previous page button data-testid

  }, _react.default.createElement("span", {
    id: id ? "".concat(id, "_pagination_item_2_button_glyphicon_chevron_left") : null,
    "aria-hidden": "true",
    className: (0, _classnames.default)(_pagerModule.default["glyphicon"], _pagerModule.default["glyphicon-chevron-left"])
  }))), _lodash.default.range(pagerConfig.startPage, pagerConfig.maxPages).map(function (i, index) {
    var pageClass = i + 1 === page ? _pagerModule.default["active"] : "";
    return _react.default.createElement("li", {
      id: id ? "".concat(id, "_pagination_buttons_item_").concat(index + 3) : null,
      className: pageClass,
      key: i
    }, _react.default.createElement("button", {
      id: id ? "".concat(id, "_pagination_item_").concat(index + 3, "_button") : null,
      type: "button",
      value: i + 1,
      title: t(_resourceKeys.resourceKeys.page.key) + " ".concat(i + 1),
      onClick: function onClick() {
        return goAtPage(i + 1);
      },
      "data-testid": "page-".concat(i + 1) // Page number button data-testid

    }, i + 1));
  }), _react.default.createElement("li", {
    id: id ? "".concat(id, "_pagination_item_button_next_page") : null
  }, _react.default.createElement("button", {
    id: id ? "".concat(id, "_pagination_button_next_page") : null,
    type: "button",
    "aria-label": "Next",
    value: pagerConfig.nextPageNo,
    title: t(_resourceKeys.resourceKeys.nextPage.key),
    onClick: goAtNext,
    "data-testid": nextPageTestId // Next page button data-testid

  }, _react.default.createElement("span", {
    id: id ? "".concat(id, "_pagination_button_next_page_glyphicon_chevron_right") : null,
    "aria-hidden": "true",
    className: (0, _classnames.default)(_pagerModule.default["glyphicon"], _pagerModule.default["glyphicon-chevron-right"])
  }))), _react.default.createElement("li", {
    id: id ? "".concat(id, "_pagination_item_button_last_page") : null
  }, _react.default.createElement("button", {
    id: id ? "".concat(id, "_pagination_button_last_page") : null,
    type: "button",
    "aria-label": "Last",
    value: totalPages,
    title: t(_resourceKeys.resourceKeys.lastPage.key),
    onClick: goAtEnd,
    "data-testid": lastPageTestId // Last page button data-testid

  }, _react.default.createElement("span", {
    id: id ? "".concat(id, "_pagination_button_last_page") : null,
    "aria-hidden": "true",
    className: (0, _classnames.default)(_pagerModule.default["glyphicon"], _pagerModule.default["glyphicon-chevron-right"])
  }), _react.default.createElement("span", {
    id: id ? "".concat(id, "_pagination_button_last_page_glyphicon_chevron_right") : null,
    "aria-hidden": "true",
    className: (0, _classnames.default)(_pagerModule.default["glyphicon"], _pagerModule.default["glyphicon-option-vertical"])
  })))))));
};

Pager.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** Number the specifies the size of each page */
  pageSize: _propTypes.default.number.isRequired,

  /** The total items that are paged */
  totalItems: _propTypes.default.number.isRequired,

  /** The total pager items*/
  totalPages: _propTypes.default.number.isRequired,

  /** The current page of the pager */
  page: _propTypes.default.number.isRequired,

  /** Callback invoked when go at previous button is clicked */
  goAtPrevious: _propTypes.default.func.isRequired,

  /** Callback invoked when  the go at next button is clicked */
  goAtNext: _propTypes.default.func.isRequired,

  /** Callback invoked when the go at start button is clicked */
  goAtStart: _propTypes.default.func.isRequired,

  /** Callback invoked when the go at end button is clicked */
  goAtEnd: _propTypes.default.func.isRequired,

  /** Callback invoked when user clicks at a numbered page item */
  goAtPage: _propTypes.default.func.isRequired,

  /** Test ID for the first page button */
  firstPageTestId: _propTypes.default.string,

  /** Test ID for the previous page button */
  previousPageTestId: _propTypes.default.string,

  /** Test ID for the next page button */
  nextPageTestId: _propTypes.default.string,

  /** Test ID for the last page button */
  lastPageTestId: _propTypes.default.string,

  /** Test ID for the entire pagination wrapper */
  paginationWrapperTestId: _propTypes.default.string,

  /** Test ID for the records shown */
  paginationRecordsShownTestId: _propTypes.default.string
};
var _default = Pager;
exports.default = _default;